import { useNavigate } from 'react-router';
import {
  Breadcrumbs,
  Link,
  Typography,
  IconButton,
  Tooltip,
  Box,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const NewHeaderBreadcrumbs = ({ links }) => {
  const linksLength = links.length;
  const navigate = useNavigate();

  const handleLinkClick = (e, href) => {
    e.preventDefault();
    navigate(href);
  };

  const handleEditClick = (e, onEditClick) => {
    e.preventDefault();
    e.stopPropagation();
    if (onEditClick) {
      onEditClick();
    }
  };

  return (
    <Breadcrumbs sx={{ fontSize: '0.875rem' }}>
      {links.map((link, i) => {
        const last = i === linksLength - 1;

        return last ? (
          <Typography
            key={link.href ?? link.name}
            sx={{
              color: 'text.primary',
              fontSize: '0.875rem',
            }}
          >
            {link.name}
          </Typography>
        ) : (
          <Box
            key={link.href ?? link.name}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            <Link
              underline="hover"
              color="inherit"
              href={link.href}
              onClick={(e) => handleLinkClick(e, link.href)}
              sx={{ fontSize: '0.875rem', color: '#919EAB' }}
            >
              {link.name}
            </Link>
            {link.showEditIcon && link.onEditClick && (
              <Tooltip title="Edit" placement="top" arrow>
                <IconButton
                  size="small"
                  onClick={(e) => handleEditClick(e, link.onEditClick)}
                  sx={{
                    p: 0.25,
                    color: 'text.secondary',
                    '&:hover': {
                      color: 'primary.main',
                    },
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      })}
    </Breadcrumbs>
  );
};

export default NewHeaderBreadcrumbs;
